// extracted by mini-css-extract-plugin
var _1 = "Pagination_pages__be2a3";
var _2 = "Pagination_root__e1c9f";
export { _1 as "pages", _2 as "root" }
